import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { spacing } from '../constants/spacing';
import { useAppColors } from '../context/PreferencesContext';

type Props = {
  loading?: boolean;
};

/** Simple footer shown while the next backend page loads. */
export function PaginationFooter({ loading }: Props) {
  const palette = useAppColors();
  if (!loading) return null;
  return (
    <View
      style={styles.footer}
      accessibilityRole="progressbar"
      accessibilityLabel="Loading more"
    >
      <ActivityIndicator color={palette.primary} />
    </View>
  );
}

const styles = StyleSheet.create({
  footer: { paddingVertical: spacing.lg, alignItems: 'center' },
});
